import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, User, Instagram, Youtube, Twitter } from 'lucide-react';

const BACKEND_URL = window.__BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Creators = () => {
  const [creators, setCreators] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const orgsResponse = await axios.get(`${API}/organizations`, { withCredentials: true });
      setOrganizations(orgsResponse.data);

      if (orgsResponse.data.length > 0) {
        const creatorsResponse = await axios.get(
          `${API}/creators?org_id=${orgsResponse.data[0].id}`,
          { withCredentials: true }
        );
        setCreators(creatorsResponse.data);
      }
    } catch (error) {
      console.error('Failed to fetch data:', error);
      toast.error('Failed to load creators');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 space-y-8" data-testid="creators-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-4xl font-bold text-white mb-2">Creator Management</h1>
          <p className="text-[#8A93A6] text-lg">Manage your content creators and profiles.</p>
        </div>
        <button className="btn-primary flex items-center gap-2" data-testid="add-creator-button">
          <Plus size={20} />
          Add Creator
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="w-12 h-12 border-4 border-[#3A7BFF] border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : creators.length === 0 ? (
        <div className="glass rounded-2xl p-12 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-[#3A7BFF]/20 flex items-center justify-center">
            <User size={40} className="text-[#3A7BFF]" />
          </div>
          <h3 className="text-xl font-bold text-white mb-2">No Creators Yet</h3>
          <p className="text-[#8A93A6] mb-6">Add your first creator to get started</p>
          <button className="btn-primary" data-testid="add-first-creator-button">
            Add Your First Creator
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {creators.map((creator) => (
            <div key={creator.id} className="glass rounded-2xl p-6" data-testid={`creator-card-${creator.id}`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#3A7BFF] to-[#39E6C8] flex items-center justify-center text-white text-2xl font-bold">
                  {creator.display_name[0]}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">{creator.display_name}</h3>
                  <p className="text-sm text-[#8A93A6]">{creator.bio || 'No bio'}</p>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex items-center gap-2 text-[#8A93A6] text-sm">
                  <Instagram size={16} />
                  <span>{creator.platform_usernames?.instagram || 'Not connected'}</span>
                </div>
                <div className="flex items-center gap-2 text-[#8A93A6] text-sm">
                  <Youtube size={16} />
                  <span>{creator.platform_usernames?.youtube || 'Not connected'}</span>
                </div>
                <div className="flex items-center gap-2 text-[#8A93A6] text-sm">
                  <Twitter size={16} />
                  <span>{creator.platform_usernames?.twitter || 'Not connected'}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Creators;
